import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Disclaimer from './components/Disclaimer';
import Features from './components/Features';
import SelfAssessments from './components/SelfAssessments';
import MoodTracker from './components/MoodTracker';
import MasterclassSeries from './components/MasterclassSeries';
import GuidedMeditation from './components/GuidedMeditation';
import MusicHub from './components/MusicHub';
import VideoHub from './components/VideoHub';
import WeeklyThoughts from './components/WeeklyThoughts';
import FinalCTA from './components/FinalCTA';
import AboutCreator from './components/AboutCreator';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8E4F3] via-[#F5F1E8] to-[#EDE7DC]">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <Features />
      <SelfAssessments />
      <MoodTracker />
      <MasterclassSeries />
      <GuidedMeditation />
      <MusicHub />
      <VideoHub />
      <WeeklyThoughts />
      <FinalCTA />
      <AboutCreator />
      <Disclaimer />
      <Footer />
    </div>
  );
}
